import DataManagement from '../dataManagement';
import { createBEM } from 'src/util/bem';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import DataManagementApi, { DataManagementDOI } from '../api/dataManagementApi';
import EnumStationType from 'src/enums/enumStationType';
import EnumOperates from 'src/enums/enumOperates';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Toast } from 'src/util/toast';
import FileUtil from 'src/util/fileUtil';
let bem = createBEM('menu-btn');

export default class DataManagementService extends ListPageService {
    ctx: DataManagement;

    get type() {
        return EnumStationType.findCode(this.ctx.$route.params.type).getId();
    }

    constructor(ctx: DataManagement) {
        super();
        this.ctx = ctx;
    }
    

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        let ctx = t.ctx;
        return [
            {
                headerName: '文件名称',
                field: 'file_name',
                minWidth: 400,
            },
        ]
    }

    async preview(params) {
        let list: Array<any> = params.data.data_url.split(",");
        list.forEach(url => {
            if(url !=""){
                FileUtil.urlPreviewFile(url);
            }
        });
    }

    async download(params) {
        let list: Array<any> = params.data.data_url.split(",");
        list.forEach(url => {
            if(url !=""){
                FileUtil.urlDownloadFile(url, params.data.file_name);
            }
        });
    }

    async delete(params) {
        let res = await Toast.confirm();
        if (!res) {
            return;
        }
        let { code } = await DataManagementApi.delete(params.data.id);
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }

    async queryDataCategories() {
        let ctx = this.ctx;
        if (!ctx.isModal) {
            let { data, code } = await DataManagementApi.searchDataCategoriesById()
            if (code === 0) {
                this.ctx.dataCategories = data.map(i => ({ name: i.data_name, value: i.id }))
                this.ctx.currentDataCategories = data[0].id
            }
        }
        await this.searchTable()
    }


    @override
    async searchTable() {
        let t = this;
        let ctx = this.ctx;
        if (ctx.currentDataCategories != null) {
            let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
            ag.showLoading();
            let res = "";
            if (ctx.currentDataCategories != 0) {
                ctx.columnDefs = [
                    ...this.createColumns(),
                    {
                        headerName: '操作',
                        field: 'operate',
                        minWidth: 280,
                        maxWidth: 280,
                        cellRendererFramework: CellOperate,
                        cellRendererFrameworkOpt: [
                            {
                                text: '预览',
                                click: t.preview.bind(t),
                            },
                            {
                                text: '下载',
                                click: t.download.bind(t),
                            },
                            {
                                text: '删除',
                                click: t.delete.bind(t),
                            }
                        ],
                    },
                ];
                res = await DataManagementApi.userQueryList({
                    ...ctx.searchParams,
                    type: this.type,
                    page_size: ctx.pageSize,
                    page_index: ctx.currentPage,
                    data_id: ctx.currentDataCategories,
                });
            }
            else {
                ctx.columnDefs = [
                    ...this.createColumns(),
                    {
                        headerName: '操作',
                        field: 'operate',
                        minWidth: 280,
                        maxWidth: 280,
                        cellRendererFramework: CellOperate,
                        cellRendererFrameworkOpt: [
                            {
                                text: '删除',
                                click: t.delete.bind(t),
                            },
                        ],
                    },
                ];
                res = await DataManagementApi.queryMyData({
                    ...ctx.searchParams,
                    type: this.type,
                    page_size: ctx.pageSize,
                    page_index: ctx.currentPage,
                });
            }
            ag.hideLoading();
            let { code, data } = res;
            if (code === 0) {
                ctx.rowData = data.data_info || [];
                ctx.total = data.page_count;
            }
        }
    }
}